<template>
  <div style="margin-bottom: 10px;">
    <label class="template-item">
      <input
        type="radio"
        @click="updateButtons('grades')"
        name="switch-template-button"
        :checked="checkedGrades"
      />
      {{$t('actionTranslateUpdate.templateTranslateRef.buttonScale')}}
      <font-awesome-icon
        style="color: #4ce595;"
        :icon="['fas', 'check-circle']"
      />
      <div class="bg-icon"></div>
    </label>
    <label class="template-item">
      <input
        type="radio"
        @click="updateButtons('button')"
        name="switch-template-button"
        :checked="checkedButton"
      />
      {{$t('actionTranslateUpdate.templateTranslateRef.button')}}
      <font-awesome-icon
        style="color: #4ce595;"
        :icon="['fas', 'check-circle']"
      />
      <div class="bg-icon"></div>
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ButtonsTemplatesSearch',
  data: () => ({
    userAuth: null,
    checkedButton: false,
    checkedGrades: false,
  }),

  computed: {
    ...mapState('actions', ['action']),
  },
  methods: {
    updateButtons(value) {
      if (value === 'grades') {
        this.action.email.template.scaleLayout = 'grades';
      } else {
        this.action.email.template.scaleLayout = 'button';
      }
    },
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (this.action.email.template.scaleLayout === 'button') {
      this.checkedButton = true;
      this.checkedGrades = false;
    }

    if (this.action.email.template.scaleLayout === 'grades') {
      this.checkedButton = false;
      this.checkedGrades = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.template-item {
  display: inline-block;
  background-color: $secondary;
  color: $white;
  margin: 1px;
  padding: 2px 5px;
  position: relative;
  font-size: 0.9em;
  cursor: pointer;
  > svg {
    display: none;
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 1;
  }
  > .bg-icon {
    background-color: $white;
    width: 14px;
    height: 14px;
    position: absolute;
    top: -5px;
    right: -5px;
    border-radius: 100%;
    z-index: 0;
    display: none;
  }
  .remove-template {
    cursor: pointer;
    > svg {
      // display: none;
      position: absolute;
      top: -5px;
      right: -5px;
      z-index: 1;
    }
    > .bg-icon {
      background-color: $white;
      width: 14px;
      height: 14px;
      position: absolute;
      top: -5px;
      right: -5px;
      border-radius: 100%;
      z-index: 0;
    }
  }
}

input[type='radio'] {
  display: none;
  &:checked {
    ~ svg {
      display: block;
    }
    ~ .bg-icon {
      display: block;
    }

    ~ .remove-template {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/scale-layout-options/index.vue